<template>
  <div
    class="checkbox" 
    :class="{checked:modelValue, disabled:disabled}" 
    :tabindex="disabled ? -1 : 0"
    @click="toggle(!modelValue)"
    @keyup.enter="toggle(!modelValue)"
  >
    {{ label }}
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: "Checkbox",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: [
    'update:modelValue'
  ],
  methods: {
    toggle(value: boolean): void {
      this.$emit('update:modelValue', value)
    }
  }
});
</script>

<style lang="scss" scoped>

.checkbox {
  color: $Color-font-high;
  cursor: pointer;
  font-size: 15px;
  padding-left: 27px;
  position: relative;  

  &::before {
    background-color: $Color-white;
    border: 1px solid $Color-fill-black;
    content: " ";
    height: 15px;
    left: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 15px;
  }

  &.checked::after {
    border-bottom: 2px solid $Color-white;
    border-right: 2px solid $Color-white;
    content: " ";
    height: 10px;
    left: 5px;
    position: absolute;
    top: 45%;
    transform: translateY(-50%) rotate(35deg);
    width: 5px;
  }

  &.checked::before {
    background-color: $Color-sac-orange;
  }

  &.disabled {
    pointer-events: none;

    &::before {
      background-color: $Color-fill-dark-gray;
    }

    &.checked::before {
      background-color: $Color-sac-orange-disabled;
    }
  }
}
</style>